<template>
	<article class="site-page" style="background:#EFEEF3;">
		<section class="site-list-wrap">
      <div class="order-info flex_wrap"style="background:rgb(22, 131, 77);padding:0;"@click="back">
       <i class="ivu-icon ivu-icon-ios-arrow-back" style="font-size:30px;color: white;"></i>
      </div>

      <template v-for="(address, index, key) in addressList" v-if="address.IsDefault==true">
				<div style="display: flex;flex-direction: column;width: 100%;background: white;padding: 10px 0;">
          <div style="display: flex;width: 100%;">
            <div style="background: rgb(22, 131, 77);height: 20px;margin: 0px 10px 0px 15px;color: white;border-radius: 50px;text-align: center;width: 50px;line-height: 20px;">
              默认
            </div>
            <div style="display: flex;flex-direction: column;">
              <div>{{ address.Province }} {{ address.City }} {{ address.District }}</div>
              <div style="margin: 5px 0;font-size: 17px;font-weight: bold;">{{ address.Address }}</div>
              <div>{{ address.Contact }} {{ address.Mobile }}</div>
            </div>
          </div>

          <div>
            <img src="../assets/siteline.png" style="width: 100%;height: 5px;" />
          </div>
				</div>
			</template>

      <div @click="addNewAddress">
        <div @click="addNewAddress" style="background: white;margin: 5px 0;padding: 5px;font-size: 18px;font-weight: bold;">
          <Icon type="ios-add" size='25' style="margin: 0 0 0 60px;" />新增地址</div>
      </div>

      <template v-for="(address, index, key) in addressList">
				<div style="background: white;padding: 10px;margin-bottom: 10px;">
          <div style="margin: 0 0 0 55px;border-left: 2px solid #16834d;padding-left: 5px;" @click.stop.prevent="setDefaultAddress(address)">{{ address.Contact }} {{ address.Mobile }}</div>
          <div style="margin: 5px 0 5px 60px;" @click.stop.prevent="setDefaultAddress(address)">{{ address.Province }}{{ address.City }}{{ address.District }}{{ address.Address }}</div>
          <div style="margin: 0 0 0 60px;">
            <button style="background:#439A6F;color:white;border-radius: 30px;width: 60px;border: none;margin-right: 10px;" @click="editAddress(address)">编辑</button>
						<button style="background:#E4E4E4;color:#7A7A7A;border-radius: 30px;width: 60px;border: none;" @click="deleteAddress(address)">删除</button>
          </div>
				</div>
			</template>

		</section>
	</article>
</template>

<script>
import addressApi from '../request/addressApi';
export default {
	name: 'MyAddressManager',
	data() {
		return {
			ifSingle: false,
			addressList: [], // 地址列表数组
			mode: '' // 页面模式，若由路由传入choose则选择默认地址后会返回上一传，若不是则选择默认地址后会跳到用户中心首页。
		};
	},

	activated() {
		// 每次进入页面时触发
		this.mode = this.$route.params.mode; // 接收传入的mode参数
		this.$nextTick(() => {
			this.getUserAddress(); // 加载客户地址列表
		});
	},
	updated() {
		this.singleList();
	},
	methods: {
		singleList() {
			if (this.addressList.length == 1) {
				this.ifSingle = true;
			} else {
				this.ifSingle = false;
			}
		},
		setDefaultAddress(address) {
      console.log(this.mode)
			let that = this;
			// 修改客户默认地址，方法传入地址Model
			if (address && address != null && address.ID > 0) {
				this.addressList.forEach(item => {
					item.IsDefault = false;
				});
				console.log('setDefaultAddress');
				address.IsDefault = true; // 修改地址Model的IsDefault为true，再调用修改地址接口。
				addressApi.updateAddress(that.$store.state.user.OpenId, address).then(sucRes => {
					if (sucRes.success) {
						if (this.mode == 'choose') {
							// 若为choose，则路由栈-1回到上页（一般为购票页选择接送服务。）
							// this.$nextTick(() => {
								this.$router.go(-1);
                // this.$router.replace({
                // 	name: 'HqPublicOrderPage',
                // 	params: {
                // 		name: 'zsairport'
                // 	}
                // });
							// });
						} else {
							// 若不是choose，则清空路由栈到个人中心。
							console.log('backIndex');
							this.$router.replace({
								name: 'MainIndexPage',
								params: {
									page: 'myuser'
								}
							});
						}
					}
				});
			}
		},
		addNewAddress() {
			// 跳转到添加地址页
			this.$router.push({
				name: 'EditAddress',
				params: {
					type: 'add',
					id: 0
				}
			});
		},
		getUserAddress() {
			// 获取地址列表
			this.addressList = [];
			this.$Spin.show();
			addressApi.getAddressList(this.$store.state.user.OpenId, '').then(sucRes => {
				if (sucRes.success && sucRes.data.length > 0) {
					this.addressList = sucRes.data;
				} else {
					// if (this.mode == 'choose') {
					//   this.addNewAddress();
					// }
				}
				this.$Spin.hide();
			});
		},
		editAddress(address) {
			// 跳到修改地址页
			if (address != undefined) {
				this.$router.push({
					name: 'EditAddress',
					params: {
						type: 'edit',
						id: address.ID
					}
				});
			}
		},
		deleteAddress(address) {
			// 作废地址
			if (address != undefined) {
				address.Status = false;
				addressApi.updateAddress(this.$store.state.user.OpenId, address).then(sucRes => {
					if (sucRes.success) {
						this.$Message.success(sucRes.message);
						this.getUserAddress();
					}
				});
			}
		},
    back(){
       this.$router.go(-1);
    },
	}
};
</script>

<style scoped lang="less">
@import '../style/variable';
@import '../style/public';

.site-page {
	.site-list-wrap {
		flex: 1;
		overflow: auto;
	}
}
.site_wrap {
	background-color: #f8f8f8;
	.border-B;
	&:nth-child(n + 2) {
		.border-T;
		margin-top: 3%;
	}
	&:last-child {
		margin: 3% auto;
	}
	.site_linkman,
	.site_info {
		.border-B(1px, dashed, rgba(0, 0, 0, 0.4));
		.blockPadding(1%);
		& span {
			line-height: 0.8rem;
		}
	}
	.site_linkman {
		.flex_wrap(space-between);
	}
	.site_info {
		.site {
			line-height: 1.5em;
			font-size: 0.35rem;
		}
	}
	&.single-list {
		margin: 0;
	}
	.sitelist_function_btn_wrap {
		.blockPadding(0);
		.flex_wrap(space-between, center);
		.site_lable {
			position: relative;
			font-size: 0.4rem;
			.flex_wrap(initial, center);
			& > .iconfont {
				font-size: 0.5rem;
				color: #006535;
				margin: 2px 5px 0 0;
			}
		}
	}
}

//=================================================================================

.little_btn {
	margin: 0 10px;
	padding: 5px;
	letter-spacing: 5px;
	text-indent: 5px;
	border-radius: 5px;
	font-size: 0.35rem;
}
.sitelist_function_btn_wrap .little_btn,
.information_operation .little_btn {
	margin: 0.5em;
	padding: 2px 4px;
}
.redact_btn,
.add_site_btn {
	background-color: #006535;
	color: #fff;
	border: 1px solid #3287b4;
}
.redact_btn:active,
.add_site_btn:active {
	background-color: #1d8ac5;
	color: #eee;
}
.cancel_btn {
	background-color: #e64340;
	color: #fff;
	border: 1px solid #b83533;
}
.cancel_btn:active {
	color: rgb(228, 228, 228);
	background-color: rgb(201, 55, 53);
}

.add_site_wrap {
}
.add_site_btn {
	width: 100%;
	line-height: 7vh;
	font-size: 0.5rem;
	padding: 0 3%;
}
</style>



// WEBPACK FOOTER //
// src/components/MyAddressManager.vue